// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React, { useState } from 'react'
import HeaderAI from '../header/HeaderAI'
import SideNavAI from '../header/SideNavAI'
import FooterAI from '../footer/FooterAI'

interface PageLayoutProps {
  alwaysDisplayWhiteBg?: boolean
  children?: any
}

const PageLayout: React.FC<PageLayoutProps> = ({ alwaysDisplayWhiteBg = false, children }) => {
  const [showMenu, setShowMenu] = useState(false)

  const toggleMenuVisibility = (): void => {
    setShowMenu((prev) => !prev)
  }

  return (
    <>
      <main data-bs-theme="light">
        <HeaderAI toggleMenuVisibility={toggleMenuVisibility} alwaysDisplayWhiteBg={alwaysDisplayWhiteBg} />
        <SideNavAI showMenu={showMenu} toggleMenuVisibility={toggleMenuVisibility} />
        {children}
        <FooterAI />
      </main>
    </>
  )
}

export default PageLayout
